import { Card } from 'react-bootstrap';
import styled from 'styled-components';

const StyledSolutionCard = styled(Card)`
  border: 2px solid #42ba96;
`;

export default StyledSolutionCard;
